import Raven from 'raven-js';
export function captureException(exception) {
  Raven.captureException(exception);
}
export function captureMessage(message, options) {
  Raven.captureMessage(message, options);
}